import View from 'root/view/base';

var Wordpress = View.extend({
        className: 'box-medium box-integration',

        events: {
            'click .download': 'download'
        },

        dom_handlers: {
            download: function() {
                window.open('https://wordpress.org/plugins/userback', '_blank', 'noopener');
            },
        },

        render: function() {
            var content = '';

            var content =
            '<div class="thumbnail">' +
                '<img src="/image/wordpress_logo.png">' +
            '</div>' +
            '<div class="content">' +
                '<h3>WordPress</h3>' +
                '<div>Get feedback from your WordPress website with screenshots from Userback. Download the plugin to enable Userback on specific, all or draft pages only.</div>' +
            '</div>' +
            '<div class="action">' +
                '<button type="button" class="tertiary small download">Download</button>' +
            '</div>';

            this.$el.html(content);

            return this;
        }
    });

    export default Wordpress;